import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: HeaderState = {
  sessionTitle: null,
  isHistory: true,
  loading: false,
  error: null,
  data: null,
};

interface CreateHeaderRequest {
    id: string;              // header parameter
    body: {
      header: string;
    };
  }
  
interface HeaderResponse {
    id: number | string;
    header: string;
    session_id: string;
    created_at: string;
    updated_at: string;
  }
  
interface HeaderState {
    sessionTitle: string | null;
    isHistory: boolean;
    loading: boolean;
    error: string | null;
    data: HeaderResponse | null;
    bookmarkData?: BookmarkResponse | null;
  }

  interface BookmarkResponse {
    book_id: string;
    book_header: string;
  }
  

const renameTitleSlice = createSlice({
  name: "header",
  initialState,
  reducers: {
    createHeaderRequest: (state, _action: PayloadAction<CreateHeaderRequest>) => {
      state.loading = true;
      state.error = null;
    },

    createHeaderSuccess: (state, action: PayloadAction<HeaderResponse>) => {
      state.loading = false;
      state.data = action.payload;
    },

    createHeaderFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },

    clearHeaderState: (state) => {
      state.data = null;
      state.error = null;
      state.loading = false;
    },
    setSessionTitle: (state, action: PayloadAction<string>) => {
      state.sessionTitle = action.payload;
    },
    setHistoryOrBookmark: (state, action: PayloadAction<boolean>) => {
      state.isHistory = action.payload;
    },
    setBookData: (state, action: PayloadAction<BookmarkResponse>) => {
      state.bookmarkData = action.payload;
    },
  },
});

export const {
  createHeaderRequest,
  createHeaderSuccess,
  createHeaderFailure,
  clearHeaderState,
  setSessionTitle,
  setHistoryOrBookmark,
  setBookData,
} = renameTitleSlice.actions;

export const renameTitleReducer = renameTitleSlice.reducer;
export const headerActionTypes = renameTitleSlice.actions;
